<template>
    <post-layout :tab-index="tabIndex" :posts="posts">
        <template #content v-if="Object.keys(post).length">
            <div v-html="post.content"></div>
        </template>
    </post-layout>
</template>

<script>
import postLayout from './postLayout.vue';

export default {
    name: 'post',
    components: { postLayout },
    props: {
        post: {
            type: Object,
            required: true
        },
        tabIndex: {
            type: String
        },
        posts: {
            type: Array,
            required: false
        }
    }
};
</script>
